import Home from "./pages/home";
import Products from "./pages/products";
import Details from "./pages/details";
import TermsCondition from "./pages/terms_condition";
import PrivacyPolicy from "./pages/privacy_policy";
import OrderSummary from "./pages/order_Summary";
import ContactUs from "./pages/contact";
import Login from "./pages/login";
import SignUp from "./pages/signup";
import { Route, Routes } from "react-router-dom";
import GlobalStyleOverrides from "./components/theme";
import { ThemeProvider } from "@mui/material/styles";
import Leading from "./pages/landing";
import Landing from "./pages/landing";
import Dashboard from "./pages/dashBoard";
import RetailerDashboard from "./pages/retailer/RetailerDashboard";
import OrderList from "./pages/retailer/OrderList";
import Return from "./pages/retailer/Return";
import OrderIdReturn from "./pages/retailer/OrderIdReturn";
import ReturnDetails from "./pages/retailer/ReturnDetails";
import OrderDetails from "./pages/retailer/OrderDetails";
import Offers from "./pages/retailer/Offers";
import Payments from "./pages/retailer/Payments";
// import RetNavbar from "./pages/RetNavbar";
// import Sidebar from "./pages/Sidebar";

function App() {
  return (
    <>
      <ThemeProvider theme={GlobalStyleOverrides()}>
        <Routes>
          {/* <Route path="/dashboard" element={<><RetNavbar /> <Sidebar />  <Dashboard /> </>} ></Route> */}

          {/* <Route path="/dashboard" exact element={<Dashboard />} /> */}

          {/* <Route path="/landing" exact element={<Landing />} /> */}
          <Route path="/" exact element={<Landing />} />
          <Route path="/home" exact element={<Home />} />
          <Route path="/products" exact element={<Products />} />
          <Route path="/products/:categoryId" exact element={<Products />} />

          <Route path="/details" exact element={<Details />} />
          <Route path="/details/:productId" exact element={<Details />} />

          <Route path="/termscondition" exact element={<TermsCondition />} />
          <Route path="/privacy" exact element={<PrivacyPolicy />} />
          <Route path="/ordersummary" exact element={<OrderSummary />} />

          {/* <Route path="/ordersummary/:productId" exact element={<OrderSummary />} /> */}

          <Route path="/contactus" exact element={<ContactUs />} />
          <Route path="/retailer_login" exact element={<Login />} />
          <Route path="/retailer_signup" exact element={<SignUp />} />
          <Route path="*" exact element={<h1>Page Not found</h1>} />
          {/* retailer */}
          <Route path="/retailerdashboard" element={<RetailerDashboard />} />
          <Route path="/orderlist" element={<OrderList />} />
          <Route path="/retproducts" element={<Return />} />
          <Route path="/retdetails" element={<ReturnDetails />} />
          <Route path="/orderidret" element={<OrderIdReturn />} />
          <Route path="/orderdetails" element={<OrderDetails />} />
          <Route path="/offers" element={<Offers />} />
          <Route path="/payments" element={<Payments />} />
        </Routes>
      </ThemeProvider>
    </>
  );
}

export default App;
